import Vue from 'vue'

import Tooltip from './Tooltip'
import PhoneMask from './PhoneMask'
import SwipeMobile from './SwipeMobile';

Vue.directive('tooltip', Tooltip);
Vue.directive('phone', PhoneMask);
Vue.directive('touch', SwipeMobile);